import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  // Scroll to top when component mounts
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-6">
          <Button
            variant="ghost"
            asChild
            className="text-legal-blue hover:text-legal-navy">
            <Link to="/" className="flex items-center gap-2">
              <ArrowLeft size={16} />
              Back to Home
            </Link>
          </Button>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold mb-6 text-legal-navy">
          Privacy Policy
        </h1>
        <p className="text-sm text-gray-500 mb-6">
          Last updated: April 7, 2025
        </p>

        <div className="prose max-w-none prose-headings:text-legal-navy prose-a:text-legal-blue">
          <p className="mb-6">
            En MiAsistenteLegalIA, tomamos su privacidad en serio. Esta Política
            de Privacidad explica cómo recopilamos, usamos, divulgamos y
            protegemos su información cuando utiliza nuestro servicio.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Información que Recopilamos
          </h2>
          <p className="mb-4">
            Recopilamos información que usted proporciona directamente cuando
            usa nuestros servicios, incluyendo:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">
              Información personal como nombre, dirección de correo electrónico
              y datos de contacto
            </li>
            <li className="mb-2">Credenciales de cuenta</li>
            <li className="mb-2">Información de pago</li>
            <li className="mb-2">
              Contenido de las comunicaciones con nuestro servicio
            </li>
            <li className="mb-2">
              Información sobre documentos legales que crea o modifica
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Cómo Usamos Su Información
          </h2>
          <p className="mb-4">Usamos la información que recopilamos para:</p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">
              Proporcionar, mantener y mejorar nuestros servicios
            </li>
            <li className="mb-2">
              Procesar transacciones y enviar información relacionada
            </li>
            <li className="mb-2">
              Enviar mensajes administrativos y comunicaciones
            </li>
            <li className="mb-2">Responder a sus comentarios y preguntas</li>
            <li className="mb-2">Personalizar su experiencia</li>
            <li className="mb-2">
              Monitorear y analizar tendencias, uso y actividades
            </li>
            <li className="mb-2">
              Detectar, investigar y prevenir transacciones fraudulentas y otras
              actividades ilegales
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Compartir Su Información
          </h2>
          <p className="mb-6">
            No vendemos ni alquilamos su información personal a terceros.
            Podemos compartir su información con:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">
              Proveedores de servicios que nos ayudan a operar nuestro servicio
            </li>
            <li className="mb-2">
              Abogados y profesionales legales cuando sea necesario para
              proporcionar servicios legales
            </li>
            <li className="mb-2">
              Autoridades legales cuando sea requerido por ley
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Seguridad de la Información
          </h2>
          <p className="mb-6">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger su información personal. Sin embargo, ningún método de
            transmisión por Internet o almacenamiento electrónico es 100%
            seguro, por lo que no podemos garantizar su seguridad absoluta.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">Sus Derechos</h2>
          <p className="mb-6">Usted tiene derecho a:</p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">Acceder a su información personal</li>
            <li className="mb-2">Corregir información inexacta</li>
            <li className="mb-2">Solicitar la eliminación de su información</li>
            <li className="mb-2">
              Oponerse al procesamiento de su información
            </li>
            <li className="mb-2">Retirar su consentimiento</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Cambios a Esta Política
          </h2>
          <p className="mb-6">
            Podemos actualizar nuestra Política de Privacidad de vez en cuando.
            Le notificaremos de cualquier cambio publicando la nueva Política de
            Privacidad en esta página y actualizando la fecha de "Última
            actualización".
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">Contáctenos</h2>
          <p className="mb-6">
            Si tiene alguna pregunta sobre esta Política de Privacidad, por
            favor contáctenos en:
          </p>
          <p className="mb-6">
            <strong>Correo electrónico:</strong>{" "}
            notificaciones@miasistentelegalia.com
            <br />
            <strong>Dirección:</strong> Medellin,Colombia
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
